import React from 'react';
import { DisabledEnabledItem } from '../ui/DisabledEnabledItem';
import { TaxesServiceComponent } from './ui/TaxesServiceComponent';
import InclusionType from "../ui/InclusionType";
import { TaxListButtons } from './ui/TaxListButtons';

export const menuItemcolumns = [
    {
        key: 'selection', label: ""
    },
    {
        key: "name_public", label: 'name'
    },
];

export const feeColumns = [
    {
        key: 'selection', label: ""
    },
    {
        key: "fee_type", label: 'name',
        componentTransform: (fee: string, key: any) => {
            return <TaxesServiceComponent fee={fee!} />
        }
    },
];

export const taxColumns = [
    {
        key: "tax_band_name", label: 'taxes.columns.taxName'
    },
    {
        key: "tax_inclusion_type", label: 'taxes.columns.taxType',
        componentTransform: (value: string, key: any) => {
            return <InclusionType value={value} key={key} />;
        }
    },
    {
        key: "tax_percentage", label: 'taxes.columns.percentage',
        componentTransform: (value: string, key: any) => {
            return <span key={`${key}-perc`}>
                {value.toString()}%
            </span>;
        }
    },
    {
        key: "enabled", label: 'taxes.columns.status',
        componentTransform: (enabled: any, key: any) => {
            return <span key={`${key}-taxes-enabled`}>
                <DisabledEnabledItem enabled={enabled} />
            </span>;
        },
    },
    {
        key: "tax_band_name", label: '',
        componentTransform: (taxName: any, key: any, props: any) => {
            return <TaxListButtons id={key} taxName={taxName} {...props} />;
        },
    },
];